/** biome-ignore-all lint/correctness/useUniqueElementIds: NA */
import { BottomSlot, LeftSlot, RightSlot, TopSlot } from 'virtual:tidal-sandbox-list'
import clsx from 'clsx'
import { config } from '../utils/config.js'
import { useTidalSandboxStateField } from './atoms/tidalSandboxState.js'
import { Grid } from './Grid.js'
import classes from './layout.module.css'
import { Navigation } from './Navigation/Navigation.js'
import { Preview } from './Preview.js'

const leftSlotLabel = config.slots?.left ?? 'Left'
const topSlotLabel = config.slots?.top ?? 'Top'
const rightSlotLabel = config.slots?.right ?? 'Right'
const bottomSlotLabel = config.slots?.bottom ?? 'Bottom'

export function Layout() {
  const [sidebarPosition, setSidebarPosition] = useTidalSandboxStateField('sidebarPosition')

  const stackCls = clsx(classes.stack, sidebarPosition === 'row' ? classes.row : classes.rowReverse)

  return (
    <Grid
      bottom={BottomSlot ? <BottomSlot id="bottom-slot" key="bottom-slot" label={bottomSlotLabel} /> : undefined}
      left={LeftSlot ? <LeftSlot id="left-slot" key="left-slot" label={leftSlotLabel} /> : undefined}
      right={RightSlot ? <RightSlot id="right-slot" key="right-slot" label={rightSlotLabel} /> : undefined}
      top={TopSlot ? <TopSlot id="top-slot" key="top-slot" label={topSlotLabel} /> : undefined}
    >
      <div className={stackCls}>
        <Navigation onChangeSidebarPosition={setSidebarPosition} sidebarPosition={sidebarPosition} />
        <Preview />
      </div>
    </Grid>
  )
}
